<st-date-range-pager
    #dateRangePager
    datePickerEnabled
    [period]="currentPeriod()"
    [dayCount]="1" />
